import * as yup from "yup";

export default function selectCategorySchema() {
  return yup.object().shape({
    categoryId: yup.string().required(),
  });
}
